@use './index' as tokens;

:export {
    // Curated list, kept manual on purpose: see .github/decisions/design-system-token-layer.md.

    // Chart series and chrome. Recharts takes colours as JS strings, so these have to
    // cross the bridge instead of being written as CSS.
    purple-300: tokens.$ynt-purple-300;
    purple-500: tokens.$ynt-purple-500;
    purple-700: tokens.$ynt-purple-700;
    purple-900: tokens.$ynt-purple-900;
    gray-400: tokens.$ynt-gray-400;
    gray-500: tokens.$ynt-gray-500;
    gray-600: tokens.$ynt-gray-600;
    gray-700: tokens.$ynt-gray-700;
    gray-800: tokens.$ynt-gray-800;

    // Chart text. SVG text inherits nothing useful, so recharts has to be told the
    // face and size explicitly.
    font-geist: tokens.$ynt-font-geist;
    size-12: tokens.$ynt-size-12;
    size-16: tokens.$ynt-size-16;
    text-primary: tokens.$ynt-text-primary;
    text-secondary: tokens.$ynt-text-secondary;
    text-tertiary: tokens.$ynt-text-tertiary;
    border-default: tokens.$ynt-border-default;

    // The Data series ramp. A chart draws a series in one of these and hands the tooltip
    // the same hue key, so the swatch in the tooltip is the line on the chart —
    // #core/utils/data-colors.ts is the one place that pairs them.
    data-blue-solid: tokens.$ynt-data-blue;
    data-red-solid: tokens.$ynt-data-red;
    data-amber-solid: tokens.$ynt-data-amber;
    data-green-solid: tokens.$ynt-data-green;
    data-teal-solid: tokens.$ynt-data-teal;
    data-purple-solid: tokens.$ynt-data-purple;
    data-pink-solid: tokens.$ynt-data-pink;
    data-blue-subtle: tokens.$ynt-info-subtle;

    // Badge fills, so a free-form colour (a work type's) can be matched to the nearest badge type.
    badge-bg-secondary: tokens.$ynt-gray-300;
    badge-bg-brand: tokens.$ynt-purple-700;
    badge-bg-informative: tokens.$ynt-blue-700;
    badge-bg-success: tokens.$ynt-green-700;
    badge-bg-warning: tokens.$ynt-amber-400;
    badge-bg-danger: tokens.$ynt-red-700;
    badge-bg-teal: tokens.$ynt-teal-700;
    badge-bg-pink: tokens.$ynt-pink-700;

    size-2: tokens.$ynt-size-2;
    size-4: tokens.$ynt-size-4;
    size-8: tokens.$ynt-size-8;
    tooltip-offset: tokens.$ynt-tooltip-offset;
    tooltip-viewport-margin: tokens.$ynt-tooltip-viewport-margin;

    // Floating UI keeps a closing panel mounted for this long, so its exit can play.
    motion-feedback-duration: tokens.$ynt-motion-feedback-duration;
    motion-transition-duration: tokens.$ynt-motion-transition-duration;
    motion-transition-easing: tokens.$ynt-motion-transition-easing;
    // How long a check springs in, so a view can let it play before it moves on.
    motion-pop-in-duration: tokens.$ynt-motion-pop-in-duration;

    // A drawer's resize handle never drags it narrower than this.
    drawer-width: tokens.$ynt-drawer-width;

    breakpoint-mobile: tokens.$ynt-breakpoint-480;
    breakpoint-tablet: tokens.$ynt-breakpoint-768;
    breakpoint-desktop: tokens.$ynt-breakpoint-1024;
    breakpoint-xlarge: tokens.$ynt-breakpoint-1280;
}
